/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Reservation,
    ReservationFromJSON,
    ReservationToJSON,
} from '../models';

export interface ApiReservationsIdDeleteRequest {
    id: number;
}

export interface ApiReservationsIdGetRequest {
    id: string;
}

export interface ApiReservationsIdPutRequest {
    id: number;
    reservation: Reservation;
}

export interface ApiReservationsPostRequest {
    reservation: Reservation;
}

/**
 * 
 */
export class ReservationsApi extends runtime.BaseAPI {

    /**
     */
    async apiReservationsGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Reservation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/reservations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReservationFromJSON));
    }

    /**
     */
    async apiReservationsGet(initOverrides?: RequestInit): Promise<Array<Reservation>> {
        const response = await this.apiReservationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiReservationsIdDeleteRaw(requestParameters: ApiReservationsIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiReservationsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/reservations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiReservationsIdDelete(requestParameters: ApiReservationsIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiReservationsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiReservationsIdGetRaw(requestParameters: ApiReservationsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Reservation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiReservationsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/reservations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReservationFromJSON(jsonValue));
    }

    /**
     */
    async apiReservationsIdGet(requestParameters: ApiReservationsIdGetRequest, initOverrides?: RequestInit): Promise<Reservation> {
        const response = await this.apiReservationsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiReservationsIdPutRaw(requestParameters: ApiReservationsIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiReservationsIdPut.');
        }

        if (requestParameters.reservation === null || requestParameters.reservation === undefined) {
            throw new runtime.RequiredError('reservation','Required parameter requestParameters.reservation was null or undefined when calling apiReservationsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/reservations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReservationToJSON(requestParameters.reservation),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiReservationsIdPut(requestParameters: ApiReservationsIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiReservationsIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiReservationsPostRaw(requestParameters: ApiReservationsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.reservation === null || requestParameters.reservation === undefined) {
            throw new runtime.RequiredError('reservation','Required parameter requestParameters.reservation was null or undefined when calling apiReservationsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("passport", []);
        }

        const response = await this.request({
            path: `/api/reservations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReservationToJSON(requestParameters.reservation),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiReservationsPost(requestParameters: ApiReservationsPostRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiReservationsPostRaw(requestParameters, initOverrides);
    }

}
